import { m8API } from 'services/production/m8';
import { SubmitClientProductFormService } from 'types/services';

export const submitClientProductForm: SubmitClientProductFormService = async (
  params
) => {
  const { clientId, partnerId, formValues, m8ProductType } = params;

  const clientPercent = Number(formValues.discountPercent);

  await m8API.admin.setDiscount({
    idUser: clientId,
    percentageAmount: clientPercent,
    priceCalculationComponentType: m8ProductType,
  });

  if (partnerId) {
    const partnerPercent = Number(formValues.partnerPercent);

    await m8API.admin.setPartnerComissionForClient({
      idClient: clientId,
      idPartner: partnerId,
      comission: partnerPercent,
    });
  }
};
